import { render, staticRenderFns } from "./Apis.vue?vue&type=template&id=0f6dad02&"
import script from "./Apis.vue?vue&type=script&lang=js&"
export * from "./Apis.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports